import * as React from "react";
import "./footer.scss";

class Footer extends React.Component {
  public render() {
    return (
      <div className="Footer">
        <div className="Footer__links_container">
          &nbsp;
          <a
            className="Footer_link"
            href="https://www.moodys.com/proprietaryrights.aspx?lang=en&cy=global"
            target="_blank"
          >
            Proprietary Rights
          </a>
          <span className="divider"> | </span>
          <a
            className="Footer_link"
            href="https://www.moodys.com/privatepolicy.aspx?lang=en&cy=global"
            target="_blank"
          >
            Privacy Policy
          </a>
          <span className="divider"> | </span>
          <a
            className="Footer_link"
            href="https://www.moodys.com/termsofuseinfo.aspx?lang=en&cy=global"
            target="_blank"
          >
            Terms of Use
          </a>
        </div>
        <div className="Footer_Copyright">
          © Copyright 2021 Moody's Analytics, Inc. and/or its licensors and
          affiliates. All Rights Reserved.&nbsp;&nbsp;
        </div>
      </div>
    );
  }
}

export default Footer;



// WEBPACK FOOTER //
// ./src/footer/footer.tsx